// @ts-nocheck
(function() {
  'use strict';
  if (window.__megaMenuCustomInit) return;
  window.__megaMenuCustomInit = true;

  const u = window.megaMenuUtils;
  if (!u) return;
  const escapeHtml = u.escapeHtml;
  const safeUrl = u.safeUrl;
  const safeImgSrc = u.safeImgSrc;
  const safeCssColor = u.safeCssColor;

  function setupSubmenuAffordances(container, link) {
    if (link.getAttribute('aria-expanded') !== 'true') {
      link.setAttribute('aria-expanded', 'false');
    }
    const sub = container.closest('[ref="submenu[]"]');
    const hm = sub && sub.closest('header-menu');
    if (hm && sub) {
      if (container._megaMenuResizeObserver) container._megaMenuResizeObserver.disconnect();
      const ro = new ResizeObserver(function() {
        if (link.getAttribute('aria-expanded') === 'true') {
          hm.style.setProperty('--submenu-height', sub.offsetHeight + 'px');
        }
      });
      ro.observe(sub);
      container._megaMenuResizeObserver = ro;
    }
  }

  function cleanupEmptyState(container) {
    container.setAttribute('data-empty', 'true');
    const listItem = container.closest('[data-menu-list-item]');
    if (listItem) {
      const link = listItem.querySelector('[data-menu-link]');
      if (link) {
        link.removeAttribute('aria-haspopup');
        link.removeAttribute('aria-controls');
        link.removeAttribute('aria-expanded');
      }
      const sub = listItem.querySelector('.menu-list__submenu');
      if (sub) sub.remove();
    }
  }

  let retryCount = 0;
  const maxRetries = 20;
  let renderTimeout = null;
  let visibilityObserver = null;

  function renderOneContainer(container) {
    const menuHandle = (container.getAttribute('data-menu-handle') || '').trim();
    if (!menuHandle) return;

    if (container.hasAttribute('data-rendered')) return;

    const megaMenuSections = window.megaMenuConfigSections || {};
    // Guard: if config not loaded yet, exit without ANY side-effects (no cleanupEmptyState).
    // The retry loop / megaMenuConfigReady event will call us again once config is ready.
    // Without this guard, the IntersectionObserver can fire on first hover and call
    // cleanupEmptyState (which removes the submenu from the DOM) before config loads.
    if (Object.keys(megaMenuSections).length === 0) return;

    const searchHandle = menuHandle.toLowerCase().trim();
    let foundSection = null;

    for (const sectionId in megaMenuSections) {
      const section = megaMenuSections[sectionId];
      if (section && section.blocks) {
        const hasContent = section.blocks.some(function(block) {
          const blockHandle = block.settings && block.settings.menu_item_handle ? block.settings.menu_item_handle.toLowerCase().trim() : '';
          return block.type === 'mega-menu-content' && blockHandle === searchHandle;
        });
        if (hasContent) {
          foundSection = section;
          break;
        }
      }
    }

    if (!foundSection) {
      cleanupEmptyState(container);
      return;
    }

    const contentBlock = foundSection.blocks.find(function(block) {
      const blockHandle = block.settings && block.settings.menu_item_handle ? block.settings.menu_item_handle.toLowerCase().trim() : '';
      return block.type === 'mega-menu-content' && blockHandle === searchHandle;
    });
    if (!contentBlock) return;

    const layout = contentBlock.settings.layout || 'grid';
    const columnsCount = contentBlock.settings.columns_count || 3;
    const items = foundSection.blocks.filter(function(block) {
      const blockHandle = block.settings && block.settings.parent_menu_handle ? block.settings.parent_menu_handle.toLowerCase().trim() : '';
      return block.type === 'mega-menu-item' && blockHandle === searchHandle;
    });
    const banners = foundSection.blocks.filter(function(block) {
      const blockHandle = block.settings && block.settings.parent_menu_handle ? block.settings.parent_menu_handle.toLowerCase().trim() : '';
      return block.type === 'mega-menu-banner' && blockHandle === searchHandle;
    });

    if (items.length === 0 && banners.length === 0) {
      cleanupEmptyState(container);
      return;
    }

    const hasBanner = banners.length > 0;
    const effectiveColumns = hasBanner ? 2 : (contentBlock.settings.columns_count || 3);

    if (layout === 'grid') {
      const itemsByColumn = {};
      items.forEach((item) => {
        const settings = item.settings || {};
        const column = (settings.column) ? parseInt(settings.column, 10) || 1 : 1;
        const order = (settings.order) ? parseInt(settings.order, 10) || 1 : 1;
        if (!itemsByColumn[column]) itemsByColumn[column] = [];
        itemsByColumn[column].push({ item: item, order: order });
      });
      Object.keys(itemsByColumn).forEach((col) => {
        itemsByColumn[col].sort(function(a, b) { return a.order - b.order; });
      });

      let html = '<div class="mega-menu-custom__grid-outer' + (hasBanner ? ' mega-menu-custom__grid-outer--with-banner' : '') + '">';
      if (hasBanner) {
        html += '<div class="mega-menu-custom__links" style="flex: 2"><div class="mega-menu-custom__grid" style="--menu-columns-desktop: 2">';
      } else {
        html += '<div class="mega-menu-custom__grid" style="--menu-columns-desktop: ' + effectiveColumns + '">';
      }
      const colKeys = Object.keys(itemsByColumn).filter(function(c) {
        return !hasBanner || parseInt(c, 10) <= 2;
      }).sort(function(a, b) { return parseInt(a, 10) - parseInt(b, 10); });
      colKeys.forEach(function(col) {
        const colItems = itemsByColumn[col];
        colItems.forEach(function(colItem, index) {
          const item = colItem.item;
          const settings = item.settings || {};
          const column = parseInt(col, 10);
          const order = colItem.order;
          const row = index + 1;
          html += '<div class="mega-menu-item" data-column="' + column + '" data-order="' + order + '" style="grid-column: ' + column + '; grid-row: ' + row + ';">';
          html += '<div class="mega-menu-item__title-row">';
          if (settings.icon && settings.icon !== 'none') {
            html += '<div class="mega-menu-item__icon">';
            if (settings.icon === 'arrow') {
              html += '<svg class="mega-menu-item__icon-svg" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M13.9998 4.6665L12.349 6.31734L18.8648 12.8332H4.6665V15.1665H18.8648L12.349 21.6823L13.9998 23.3332L23.3332 13.9998L13.9998 4.6665Z" fill="currentColor"/></svg>';
            } else if (settings.icon === 'external') {
              html += '<svg class="mega-menu-item__icon-svg" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M16.3333 3.5V5.83333H20.5158L9.0475 17.3017L10.6983 18.9525L22.1667 7.48417V11.6667H24.5V3.5H16.3333Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M5.83333 22.1667H24.5V24.5H5.83333C4.54417 24.5 3.5 23.4558 3.5 22.1667V3.5H5.83333V22.1667Z" fill="currentColor"/></svg>';
            }
            html += '</div>';
          }
          if (settings.title) html += '<h3 class="mega-menu-item__title">' + escapeHtml(settings.title) + '</h3>';
          html += '</div>';
          if (settings.image) {
            const imgSrc = safeImgSrc(settings.image);
            if (imgSrc) html += '<div class="mega-menu-item__image"><img src="' + imgSrc + '" alt="' + escapeHtml(settings.title || '') + '" loading="lazy" class="mega-menu-item__image-img"></div>';
          }
          if (settings.description) html += '<p class="mega-menu-item__description">' + escapeHtml(settings.description) + '</p>';
          if (settings.url) html += '<a href="' + safeUrl(settings.url) + '" class="mega-menu-item__link" title="' + escapeHtml(settings.title || '') + '"></a>';
          html += '</div>';
        });
      });
      if (hasBanner) {
        html += '</div></div><div class="mega-menu-custom__right mega-menu-custom__right--banner">';
        const banner = banners[0].settings || {};
        html += '<div class="mega-menu-banner" style="background-color: ' + safeCssColor(banner.background_color) + '">';
        if (banner.heading) html += '<h3 class="mega-menu-banner__heading">' + escapeHtml(banner.heading) + '</h3>';
        html += '<div class="mega-menu-banner__article">';
        if (banner.image) {
          const bannerImgSrc = safeImgSrc(banner.image);
          if (bannerImgSrc) html += '<div class="mega-menu-banner__image"><img src="' + bannerImgSrc + '" alt="' + escapeHtml(banner.title || '') + '" loading="lazy" class="mega-menu-banner__image-img"></div>';
        }
        html += '<div class="mega-menu-banner__content">';
        if (banner.title) html += '<h4 class="mega-menu-banner__title">' + escapeHtml(banner.title) + '</h4>';
        if (banner.description) html += '<p class="mega-menu-banner__description">' + escapeHtml(banner.description) + '</p>';
        if (banner.button_url && banner.button_text) html += '<a href="' + safeUrl(banner.button_url) + '" class="mega-menu-banner__cta"><span class="mega-menu-banner__cta-text">' + escapeHtml(banner.button_text) + '</span><svg class="mega-menu-banner__cta-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';
        html += '</div></div></div></div></div>';
      } else {
        html += '</div></div>';
      }

      container._megaMenuHTML = html;
      container._megaMenuHandle = menuHandle;
      try {
        container.innerHTML = html;
        container.setAttribute('data-js-rendered', 'true');
        /* Defensive: restore content if something else removes it. Prefer fixing the root cause. */
        const observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
              const hasOurContent = container.querySelector('.mega-menu-custom__grid') !== null;
              if (!hasOurContent && container._megaMenuHTML) {
                container.innerHTML = container._megaMenuHTML;
                container.setAttribute('data-js-rendered', 'true');
              }
            }
          });
        });
        observer.observe(container, { childList: true, subtree: true });
        container._megaMenuObserver = observer;
        container.setAttribute('data-rendered', 'true');
        const listItem = container.closest('[data-menu-list-item]');
        if (listItem) {
          listItem.setAttribute('data-mega-has-dropdown', 'true');
          const link = listItem.querySelector('[data-menu-link]');
          if (link) {
            const submenuInner = container.closest('.menu-list__submenu-inner');
            if (submenuInner && submenuInner.id) link.setAttribute('aria-controls', submenuInner.id);
            link.setAttribute('aria-haspopup', 'true');
            setupSubmenuAffordances(container, link);
          }
        }
        if (typeof window.megaMenuRestoreAffordances === 'function') window.megaMenuRestoreAffordances();
      } catch (err) {
        console.error('Mega menu render error (grid)', { menuHandle: menuHandle, error: err });
      }
    } else if (layout === 'columns') {
      const itemsByColumnCol = {};
      items.forEach(function(item) {
        const settings = item.settings || {};
        const column = (settings.column) ? parseInt(settings.column, 10) || 1 : 1;
        const order = (settings.order) ? parseInt(settings.order, 10) || 1 : 1;
        if (!itemsByColumnCol[column]) itemsByColumnCol[column] = [];
        itemsByColumnCol[column].push({ item: item, order: order });
      });
      Object.keys(itemsByColumnCol).forEach(function(col) {
        itemsByColumnCol[col].sort(function(a, b) { return a.order - b.order; });
      });
      const columnHeadings = [contentBlock.settings.column_1_heading, contentBlock.settings.column_2_heading];
      const colKeysCol = Object.keys(itemsByColumnCol).sort(function(a, b) { return parseInt(a, 10) - parseInt(b, 10); });
      let htmlCol = '<div class="mega-menu-custom__columns"><div class="mega-menu-custom__left">';
      colKeysCol.forEach(function(col, colIndex) {
        const colItems = itemsByColumnCol[col];
        const heading = columnHeadings[colIndex];
        htmlCol += '<div class="mega-menu-custom__column">';
        if (heading) htmlCol += '<h3 class="mega-menu-custom__column-heading">' + escapeHtml(heading) + '</h3>';
        colItems.forEach(function(colItem) {
          const item = colItem.item;
          const settings = item.settings || {};
          const column = parseInt(col, 10);
          const order = colItem.order;
          htmlCol += '<div class="mega-menu-item" data-column="' + column + '" data-order="' + order + '">';
          htmlCol += '<div class="mega-menu-item__title-row">';
          if (settings.icon && settings.icon !== 'none') {
            htmlCol += '<div class="mega-menu-item__icon">';
            if (settings.icon === 'arrow') {
              htmlCol += '<svg class="mega-menu-item__icon-svg" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M13.9998 4.6665L12.349 6.31734L18.8648 12.8332H4.6665V15.1665H18.8648L12.349 21.6823L13.9998 23.3332L23.3332 13.9998L13.9998 4.6665Z" fill="currentColor"/></svg>';
            } else if (settings.icon === 'external') {
              htmlCol += '<svg class="mega-menu-item__icon-svg" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M16.3333 3.5V5.83333H20.5158L9.0475 17.3017L10.6983 18.9525L22.1667 7.48417V11.6667H24.5V3.5H16.3333Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M5.83333 22.1667H24.5V24.5H5.83333C4.54417 24.5 3.5 23.4558 3.5 22.1667V3.5H5.83333V22.1667Z" fill="currentColor"/></svg>';
            }
            htmlCol += '</div>';
          }
          if (settings.title) htmlCol += '<h3 class="mega-menu-item__title">' + escapeHtml(settings.title) + '</h3>';
          htmlCol += '</div>';
          if (settings.image) {
            const colImgSrc = safeImgSrc(settings.image);
            if (colImgSrc) htmlCol += '<div class="mega-menu-item__image"><img src="' + colImgSrc + '" alt="' + escapeHtml(settings.title || '') + '" loading="lazy" class="mega-menu-item__image-img"></div>';
          }
          if (settings.description) htmlCol += '<p class="mega-menu-item__description">' + escapeHtml(settings.description) + '</p>';
          if (settings.url) htmlCol += '<a href="' + safeUrl(settings.url) + '" class="mega-menu-item__link" title="' + escapeHtml(settings.title || '') + '"></a>';
          htmlCol += '</div>';
        });
        htmlCol += '</div>';
      });
      htmlCol += '</div><div class="mega-menu-custom__right">';
      if (banners.length > 0) {
        const bannerCol = banners[0].settings || {};
        htmlCol += '<div class="mega-menu-banner" style="background-color: ' + safeCssColor(bannerCol.background_color) + '">';
        if (bannerCol.heading) htmlCol += '<h3 class="mega-menu-banner__heading">' + escapeHtml(bannerCol.heading) + '</h3>';
        htmlCol += '<div class="mega-menu-banner__article">';
        if (bannerCol.image) {
          const colBannerImg = safeImgSrc(bannerCol.image);
          if (colBannerImg) htmlCol += '<div class="mega-menu-banner__image"><img src="' + colBannerImg + '" alt="' + escapeHtml(bannerCol.title || '') + '" loading="lazy" class="mega-menu-banner__image-img"></div>';
        }
        htmlCol += '<div class="mega-menu-banner__content">';
        if (bannerCol.title) htmlCol += '<h4 class="mega-menu-banner__title">' + escapeHtml(bannerCol.title) + '</h4>';
        if (bannerCol.description) htmlCol += '<p class="mega-menu-banner__description">' + escapeHtml(bannerCol.description) + '</p>';
        if (bannerCol.button_url && bannerCol.button_text) htmlCol += '<a href="' + safeUrl(bannerCol.button_url) + '" class="mega-menu-banner__cta"><span class="mega-menu-banner__cta-text">' + escapeHtml(bannerCol.button_text) + '</span><svg class="mega-menu-banner__cta-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';
        htmlCol += '</div></div></div>';
      }
      htmlCol += '</div></div>';

      container._megaMenuHTML = htmlCol;
      container._megaMenuHandle = menuHandle;
      try {
        container.innerHTML = htmlCol;
        container.setAttribute('data-js-rendered', 'true');
        /* Defensive: restore content if something else removes it. Prefer fixing the root cause. */
        const observerCol = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
              const hasOurContentCol = container.querySelector('.mega-menu-custom__columns') !== null;
              if (!hasOurContentCol && container._megaMenuHTML) {
                container.innerHTML = container._megaMenuHTML;
                container.setAttribute('data-js-rendered', 'true');
              }
            }
          });
        });
        observerCol.observe(container, { childList: true, subtree: true });
        container._megaMenuObserver = observerCol;
        container.setAttribute('data-rendered', 'true');
        const listItemCol = container.closest('[data-menu-list-item]');
        if (listItemCol) {
          listItemCol.setAttribute('data-mega-has-dropdown', 'true');
          const linkCol = listItemCol.querySelector('[data-menu-link]');
          if (linkCol) {
            const submenuInnerCol = container.closest('.menu-list__submenu-inner');
            if (submenuInnerCol && submenuInnerCol.id) linkCol.setAttribute('aria-controls', submenuInnerCol.id);
            linkCol.setAttribute('aria-haspopup', 'true');
            setupSubmenuAffordances(container, linkCol);
          }
        }
        if (typeof window.megaMenuRestoreAffordances === 'function') window.megaMenuRestoreAffordances();
      } catch (err) {
        console.error('Mega menu render error (columns)', { menuHandle: menuHandle, error: err });
      }
    }
  }

  function renderMegaMenu() {
    try {
      const containers = document.querySelectorAll('[data-mega-menu-container]');
      if (containers.length === 0) {
        retryCount++;
        if (retryCount < maxRetries) {
          if (renderTimeout) clearTimeout(renderTimeout);
          renderTimeout = setTimeout(renderMegaMenu, 100);
        }
        return;
      }
      if (!visibilityObserver && 'IntersectionObserver' in window) {
        visibilityObserver = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting && !entry.target.hasAttribute('data-rendered')) {
              renderOneContainer(entry.target);
            }
          });
        });
        for (var i = 0; i < containers.length; i++) {
          visibilityObserver.observe(containers[i]);
        }
      }
      const megaMenuSections = window.megaMenuConfigSections || {};
      if (Object.keys(megaMenuSections).length === 0) {
        retryCount++;
        if (retryCount < maxRetries) {
          if (renderTimeout) clearTimeout(renderTimeout);
          renderTimeout = setTimeout(renderMegaMenu, 200);
        }
        return;
      }
      retryCount = 0;
      for (let i = 0; i < containers.length; i++) {
        renderOneContainer(containers[i]);
      }
    } catch (err) {
      console.error('Mega menu render error', err);
    }
  }

  function handleMegaMenuReady() {
    renderMegaMenu();
  }

  window.addEventListener('megaMenuConfigReady', handleMegaMenuReady);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleMegaMenuReady);
  } else {
    setTimeout(handleMegaMenuReady, 100);
  }
  setTimeout(handleMegaMenuReady, 1000);
})();
